import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import { useScrollReveal } from '@/hooks/use-scroll-reveal';

export const LetsTalkCTA = () => {
  const { elementRef, getRevealStyle } = useScrollReveal();

  return (
    <section className="py-24 bg-[#0a0a0a] relative overflow-hidden">
      <div className="container-professional" ref={elementRef} style={getRevealStyle()}>
        <div className="max-w-3xl mx-auto text-center">
          <h2 className="text-3xl md:text-4xl font-bold text-white mb-6 leading-tight">
            Let's talk about what you're trying to build.
          </h2>
          <p className="text-base md:text-lg text-[rgba(255,255,255,0.65)] leading-relaxed mb-10">
            Tell us about the problem. We'll come back within 24 hours with an honest view of what's possible, roughly what it would cost, and how long it would take. No pitch. No obligation.
          </p>
          <div className="flex justify-center">
            <Link to="/contact">
              <button
                className="group relative h-12 px-8 text-sm bg-primary hover:bg-[#00d4e6] text-white font-semibold rounded-lg transition-all duration-300 hover:transform hover:-translate-y-1 flex items-center gap-2"
                style={{
                  boxShadow: '0 4px 24px -6px hsl(190 100% 50% / 0.5), 0 0 0 1px hsl(190 100% 50% / 0.1)',
                }}
              >
                <span>Book a free call</span>
                <ArrowRight className="w-4 h-4 transition-transform duration-300 group-hover:translate-x-1" />
              </button>
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
};
